import { InjectionToken } from '@angular/core';

/** When true, renders the web cabinet chrome header (logo, return-to-site). */
export const CABINET_STAFF_SHELL_SHOW_WEB_HEADER = new InjectionToken<boolean>(
  'CABINET_STAFF_SHELL_SHOW_WEB_HEADER',
  {
    factory: (): boolean => false,
  },
);
